/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const TwoPeople16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray50}
            d="M11 7.5c.452 0 .867-.112 1.247-.335.38-.224.683-.527.91-.909.229-.382.343-.813.343-1.292 0-.463-.114-.88-.342-1.253a2.515 2.515 0 00-.915-.885A2.47 2.47 0 0011 2.5c-.447 0-.86.11-1.24.33-.38.219-.684.515-.915.89A2.35 2.35 0 008.5 4.976c0 .47.115.898.345 1.28.23.382.535.685.915.909A2.4 2.4 0 0011 7.5zm-7 0c.359 0 .69-.089.994-.267.304-.177.548-.42.731-.727A1.98 1.98 0 006 5.472c0-.374-.092-.71-.275-1.008A2.004 2.004 0 004 3.5c-.354 0-.684.087-.988.261a2.044 2.044 0 00-.734.711C2.093 4.772 2 5.11 2 5.483c0 .378.092.72.275 1.025.183.306.427.548.731.725.304.178.635.267.994.267zm1.187 6c-.148-.248-.222-.55-.22-.906.002-.356.067-.73.194-1.123.127-.394.305-.776.533-1.149.229-.372.497-.7.806-.986a4.266 4.266 0 00-1.067-.6 3.69 3.69 0 00-1.36-.236c-.625 0-1.187.122-1.688.365-.5.244-.928.564-1.283.962a4.432 4.432 0 00-.818 1.303c-.19.47-.284.933-.284 1.387 0 .314.076.556.229.727.152.17.412.256.78.256h4.178zm9.522 0c.476 0 .81-.078 1.003-.233.192-.155.288-.383.288-.684 0-.432-.116-.885-.348-1.357a4.706 4.706 0 00-1-1.33 5.142 5.142 0 00-1.575-1.008C12.461 8.629 11.77 8.5 11 8.5c-.769 0-1.46.13-2.077.388a5.142 5.142 0 00-1.576 1.008 4.706 4.706 0 00-1 1.33c-.231.472-.347.925-.347 1.357 0 .301.096.53.288.684.192.155.527.233 1.003.233h7.418z"
        />
    </AccessibleSVG>
);

export default TwoPeople16;
